export default "__VITE_ASSET__e4f11b56__"